<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$email"
				start
			/>
			<translate>Email templates</translate>
			<v-spacer />
			<v-btn
				color="primary"
				variant="flat"
				prepend-icon="$plus"
				@click="goToCreate"
			>
				<translate>Create</translate>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-data-table
				:headers="headers"
				:items="emailTemplates"
				:items-per-page="-1"
			>
				<template #item.subject="{ item }">
					<a :href="`/bo/emailtemplates/edit?id=${item.id}`">
						{{ item.subject }}
					</a>
				</template>
				<template #item.delete="{ item }">
					<v-btn
						variant="text"
						color="error"
						:disabled="disableDelete(item)"
						@click.stop="deleteTemplate(item)"
					>
						<translate>Delete</translate>
					</v-btn>
				</template>
				<template #item.language.iso6391="{ value }">
					<v-img
						:src="`/images/flags/${value}.svg`"
						width="32px"
						height="24px"
					/>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>
<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, confirm,
} from 'laravel-front-library';

export default {
	name: 'EmailTemplateOverview',

	props: {
		emailTemplateType: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			emailTemplates: [],
		};
	},

	computed: {
		headers () {
			return [
				{
					title: 'id', align: 'start', sortable: true, value: 'id', filterable: false
				},
				{
					title: this.$gettext('Subject'), sortable: true, value: 'subject', filterable: true
				},
				{
					title: this.$gettext('Domain'), sortable: true, value: 'domain.name', filterable: true
				},
				{
					title: this.$gettext('Language'), sortable: true, value: 'language.iso6391', filterable: true
				},
				{
					title: '', sortable: true, value: 'delete', filterable: false
				},
			];
		},
	},

	mounted () {
		this.getTemplates();
	},

	methods: {
		/**
		 *
		 */
		goToCreate () {
			window.location.href = `/bo/emailtemplates/create?name=${this.emailTemplateType.name}`;
		},

		/**
		 * Get email template type, email template, and available purpose data for the page.
		 *
		 * @returns {void}
		 */
		getTemplates () {
			axios.get(`/api/v0/emailtemplates?emailtemplatetype_id=${this.emailTemplateType.id}`)
				.then(({
					data
				}) => {
					this.emailTemplates = data;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
				});
		},

		/**
		 * Check if a template delete should be disabled
		 *
		 * @param {object} template the template to delete
		 * @returns {boolean}
		 */
		disableDelete (template) {
			return (
				template.domain.languageId === template.languageId &&
				template.id === Math.max(...this.emailTemplates.filter((temp) => {
					return (temp.domain.id === template.domain.id && temp.languageId === template.languageId);
				}).map((temp) => temp.id))
			);
		},

		/**
		 * Send request to delete template
		 *
		 * @param {object} template the template to delete
		 */
		deleteTemplate (template) {
			confirm(this.$gettext('Are you sure you want to delete this template?'), () => {
				axios.delete(`/bo/emailtemplates?id=${template.id}`).finally(() => {
					window.location.reload();
				});
			});
		},

		/**
		 * Checks if our language is a flag path or just text.
		 *
		 * @param {string} language - language the email template is.
		 * @returns {boolean} Whether it is a flag path or not
		 */
		isFile (language) {
			return !!/(?:\.([^.]+))?$/.exec(language)[1];
		},
	}
};
</script>
